import React from 'react';
import { Heading } from '../../components';
import { FormattedMessage } from '../../util/reactIntl';
import { P } from '../PageBuilder/Primitives/P';
import classNames from 'classnames';
import moment from 'moment-timezone/builds/moment-timezone-with-data-10-year-range.min';

import css from './ListingPage.module.css';

const isTimeSlotAvailable = (data, day, timeRange, timezone) => {
  const [startTime, endTime] = timeRange.split('-').map(time => moment(time.trim(), 'HH:mm'));

  for (const monthKey in data) {
    const { timeSlots } = data[monthKey];
    if (!!timeSlots) {
      for (const slot of timeSlots) {
        const { start, end } = slot.attributes;

        const startDate = moment.tz(start, timezone).locale('en');
        const endDate = moment.tz(end, timezone).locale('en');
        if (startDate.format('dddd') === day) {
          const slotStartTime = moment(startDate.format('HH:mm'), 'HH:mm');
          const slotEndTime = moment(endDate.format('HH:mm'), 'HH:mm');

          if (startTime.isSameOrAfter(slotStartTime) && endTime.isSameOrBefore(slotEndTime)) {
            return true;
          }
        }
      }
    }
  }

  return false;
};

const SectionAvailability = props => {
  const { intl, listing, monthlyTimeSlots } = props;
  const timeZone = listing?.attributes?.availabilityPlan?.timezone;
  const timeSlots = [
    {
      label: 'Morgen',
      timeSlot: '09:00-12:00',
    },
    {
      label: 'Nachmittag',
      timeSlot: '12:00-15:00',
    },
    {
      label: 'Spätnachmittag',
      timeSlot: '15:00-18:00',
    },
    {
      label: 'Abend',
      timeSlot: '18:00-21:00',
    },
  ];
  return (
    <section id="availability" className={css.section}>
      <Heading as="h2" rootClassName={css.sectionHeading}>
        <FormattedMessage id="ListingPage.availability" />
      </Heading>
      <P className={css.sectionDescription}>
        <FormattedMessage id="ListingPage.availabilityDescription" />
      </P>
      <div className={css.sectionAvailabilityContainer}>
        <div className={css.calendarContainer}>
          <div className={classNames(css.noBorder, css.header)}></div>
          <div className={css.header}>Mon</div>
          <div className={css.header}>Tue</div>
          <div className={css.header}>Wed</div>
          <div className={css.header}>Thu</div>
          <div className={css.header}>Fri</div>
          <div className={css.header}>Sat</div>
          <div className={classNames(css.noBorder, css.header)}>Sun</div>

          {timeSlots.map(t => {
            const hasMondayAvailability = isTimeSlotAvailable(
              monthlyTimeSlots,
              'Monday',
              t.timeSlot,
              timeZone
            );
            const hasTuesdayAvailability = isTimeSlotAvailable(
              monthlyTimeSlots,
              'Tuesday',
              t.timeSlot,
              timeZone
            );
            const hasWednesdayAvailability = isTimeSlotAvailable(
              monthlyTimeSlots,
              'Wednesday',
              t.timeSlot,
              timeZone
            );
            const hasThursdayAvailability = isTimeSlotAvailable(
              monthlyTimeSlots,
              'Thursday',
              t.timeSlot,
              timeZone
            );
            const hasFridayAvailability = isTimeSlotAvailable(
              monthlyTimeSlots,
              'Friday',
              t.timeSlot,
              timeZone
            );
            const hasSaturdayAvailability = isTimeSlotAvailable(
              monthlyTimeSlots,
              'Saturday',
              t.timeSlot,
              timeZone
            );
            const hasSundayAvailability = isTimeSlotAvailable(
              monthlyTimeSlots,
              'Sunday',
              t.timeSlot,
              timeZone
            );
            return (
              <>
                <div className={css.timeslot}>
                  <div className={css.timeslotLabel}>{t.label}</div>
                  <div className={css.time}>{t.timeSlot}</div>
                </div>
                <div
                  className={classNames(css.cell, {
                    [css.timeslotAvailable]: hasMondayAvailability,
                  })}
                ></div>
                <div
                  className={classNames(css.cell, {
                    [css.timeslotAvailable]: hasTuesdayAvailability,
                  })}
                ></div>
                <div
                  className={classNames(css.cell, {
                    [css.timeslotAvailable]: hasWednesdayAvailability,
                  })}
                ></div>
                <div
                  className={classNames(css.cell, {
                    [css.timeslotAvailable]: hasThursdayAvailability,
                  })}
                ></div>
                <div
                  className={classNames(css.cell, {
                    [css.timeslotAvailable]: hasFridayAvailability,
                  })}
                ></div>
                <div
                  className={classNames(css.cell, {
                    [css.timeslotAvailable]: hasSaturdayAvailability,
                  })}
                ></div>
                <div
                  className={classNames(css.cell, {
                    [css.timeslotAvailable]: hasSundayAvailability,
                  })}
                ></div>
              </>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default SectionAvailability;
